import { ActionReducerMap, createReducer, on } from '@ngrx/store';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as ReportScheduleActions from './report-schedules.actions';
import { ReportSchedule } from '@mode/shared/schedules/contract';

export const reportSchedulesFeatureKey = 'reportSchedules';

export type ReportSchedulesState = EntityState<ReportSchedule>;
export interface ReportSchedulesFeatureState {
  reportSchedules: ReportSchedulesState;
  loading: boolean;
}

export const adapter: EntityAdapter<ReportSchedule> = createEntityAdapter<ReportSchedule>({
  selectId: (model) => model.id,
});

export const reportScheduleInitialState: ReportSchedulesFeatureState = {
  reportSchedules: adapter.getInitialState(),
  loading: false,
};

export const reportSchedulesReducer = createReducer(
  reportScheduleInitialState.reportSchedules,
  on(ReportScheduleActions.loadReportSchedulesSuccess, (state, action) => adapter.setAll(action.schedules, state)),
  on(ReportScheduleActions.deleteReportScheduleSuccess, (state, action) => adapter.removeOne(action.scheduleId, state)),
  on(ReportScheduleActions.createEmailSubscriptionSuccess, (state, action) =>
    adapter.updateOne(
      {
        changes: {
          subscribed: true,
          subscriberCount: action.subscriberCount,
          emailMemberships: action.emailSubscription,
        },
        id: action.scheduleId,
      },
      state
    )
  ),
  on(ReportScheduleActions.deleteEmailSubscriptionSuccess, (state, action) =>
    adapter.updateOne(
      {
        changes: {
          subscribed: false,
          subscriberCount: action.subscriberCount,
          emailMemberships: undefined,
        },
        id: action.scheduleId,
      },
      state
    )
  )
);

export const loadingReducer = createReducer(
  reportScheduleInitialState.loading,
  on(ReportScheduleActions.loadReportSchedules, () => true),
  on(ReportScheduleActions.loadReportSchedulesSuccess, () => false),
  on(ReportScheduleActions.loadReportSchedulesFailure, () => false)
);

export const reducer: ActionReducerMap<ReportSchedulesFeatureState> = {
  reportSchedules: reportSchedulesReducer,
  loading: loadingReducer,
};

export const { selectAll } = adapter.getSelectors();
